import React from 'react';
import { View, StyleSheet } from 'react-native';
import { useTheme } from '../../hooks/useTheme';
import ColourAnalysisScreen from '../color-analysis/ColourAnalysisScreen';
import PublicPageHeader from '../../components/landing/PublicPageHeader';

/**
 * Public Color Analysis - public screen for unauthenticated users.
 * Separate from authenticated ColourAnalysisScreen for security isolation.
 * Same implementation (1 try, blurred results, sign-up redirect).
 */
const PublicColorAnalysisScreen = () => {
  const { colors } = useTheme();

  return (
    <View style={[styles.container, { backgroundColor: colors.background }]}>
      <PublicPageHeader activeScreen="color-analysis" />
      <ColourAnalysisScreen isPublicPreview={true} />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
});

export default PublicColorAnalysisScreen;
